import DamagedPointsComponent from '@/common/components/adjusterReport/damagedPoints/DamagedPointsComponent';
import ImagePreviewDamagedPointsList from '@/common/components/adjusterReport/damagedPoints/ImagePreviewDamagedPointsList';
import PreviewImageAddDamagedPointModal from '@/common/components/adjusterReport/damagedPoints/PreviewImageAddDamagedPointModal';
import Button from '@/common/components/base/button/Button';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بازدید اولیه / تصاویر" header="titleHeader">
      <InitialVisitServerDamagedPointsPage />
    </MainLayout>
  );
};

const InitialVisitServerDamagedPointsPage = () => {
  const { closeModal, open, openModal } = useModal();

  const { damagedPoints } = useDamagedPoints();

  const hasDamagedPoints = damagedPoints.length > 0;

  return (
    <>
      <PreviewImageAddDamagedPointModal
        closeModal={closeModal}
        open={open}
        roleType="initial"
      />
      <DamagedPointsComponent
        needSelectedPoints
        userType="initial"
        header={
          <Box mt={24}>
            <Typography color="black-1" textStyle="b2">
              کارشناس محترم، در صورت داشتن نقاط آسیب‌دیده نسبت به ثبت آن اقدام
              نمایید؛ در غیر این صورت می‌توانید این مرحله را رد کنید.
            </Typography>
          </Box>
        }
        pointsList={
          <ImagePreviewDamagedPointsList participantRoleType="initial" />
        }
        buttons={
          <Box>
            <Button
              fullWidth
              mt={40}
              onClick={openModal}
              disabled={hasDamagedPoints ? false : false}
            >
              تایید و ادامه
            </Button>
          </Box>
        }
      />
    </>
  );
};
